export default () => {
  document.dispatchEvent(new MouseEvent('click')); // FIXME: hack
};
